import { TenantCustomSetting, UserTenant } from '@root/globalTypes';
import { Emptied } from '@utils/types';

export const getCustomSetting = (
  tenant: Emptied<UserTenant> | undefined,
  name: TenantCustomSetting['name'],
) => tenant?.customSettings?.find((el) => el.name === name)?.value;

export const isCustomSettingEnabled = (
  tenant: Emptied<UserTenant> | undefined,
  name: TenantCustomSetting['name'],
) => getCustomSetting(tenant, name) === true;
